
<!-- Sunsetting Banner -->
<app-script-sunset-banner></app-script-sunset-banner>

<!-- Version History Dropdown -->
@if (scriptId && versions.length > 0) {
  <mat-card style="margin-bottom: 16px;">
    <mat-card-header>
      <mat-card-title>Version History</mat-card-title>
      <mat-card-subtitle>
        Select a version to view or edit
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Select Version</mat-label>
        <mat-select [(ngModel)]="selectedVersion" (selectionChange)="onVersionChange()" [disabled]="isLoadingVersions">
          @if (isLoadingVersions) {
            <mat-option disabled>
              <mat-spinner diameter="20"></mat-spinner>
              Loading versions...
            </mat-option>
          } @else {
            @for (version of versions; track version.version) {
              <mat-option [value]="version.version">
                {{ getVersionLabel(version) }}
              </mat-option>
            }
          }
          @if (selectedVersion == 0) {
            <mat-hint>Superseded means the version has been replaced by a newer version before it was reviewed</mat-hint>
          }
        </mat-select>
      </mat-form-field>
    </mat-card-content>
  </mat-card>
}

<app-script-editor [scriptId]="scriptId" [versionId]="versionId" [showTutorial]="true" [readonly]="isReadOnly" [isExample]="isReadOnly && scriptId === 0"></app-script-editor>

@if (!isReadOnly) {
  <mat-card style="margin-top: 16px;">
      <mat-card-header>
          <mat-card-title>
              Save your work
          </mat-card-title>
          <mat-card-subtitle>
              Done editing your script for now?<br>
              Either send it in for review or continue editing later.
          </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
          <mat-action-list>
              <mat-divider></mat-divider>
                  <app-list-item-button 
                  title="I'm done editing" 
                  value="Save & Submit Changes"
                  [disabled]="isSubmitting || isSaving || hasValidationErrors || !canSubmitCurrent"
                  (clicked)="submitChanges()">
                  @if (isSubmitting) {
                      <mat-spinner diameter="20" style="margin-left: 8px;"></mat-spinner>
                  }
              </app-list-item-button>
              <mat-divider></mat-divider>
              <app-list-item-button 
                  title="I will continue editing later" 
                  value="Save Changes without Submitting"
                  [disabled]="isSubmitting || isSaving || !canSubmitCurrent"
                  (clicked)="saveChanges()">
                  @if (isSaving) {
                      <mat-spinner diameter="20" style="margin-left: 8px;"></mat-spinner>
                  }
              </app-list-item-button>
          </mat-action-list>
      </mat-card-content>
  </mat-card>
}